import {
	ApolloClient,
	ApolloProvider,
	HttpLink,
	InMemoryCache,
} from "@apollo/client";
import "@fortawesome/fontawesome-free/css/all.css";
import "bulma/css/bulma.css";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navbar from "./components/Navbar";
import SearchList from "./components/SearchList";
import Home from "./pages/Home";
import MealPlan from "./pages/MealPlan";
import Recipe from "./pages/Recipe";
import Suggestions from "./pages/Suggestions";

const client = new ApolloClient({
	cache: new InMemoryCache(),
	link: new HttpLink({
		uri: "https://recipe-graphql.herokuapp.com/graphql",
	}),
});

export default function App() {
	return (
		<div className="App">
			<Router>
				<ApolloProvider client={client}>
					<div style={{ position: "sticky", top: 0, zIndex: 999 }}>
						<Navbar />
					</div>
					<Switch>
						<Route path="/search/:q" component={SearchList} />
						<Route path="/recipe/:id" component={Recipe} />
						<Route path="/meal-plan" component={MealPlan} />
						<Route path="/suggestions" component={Suggestions} />
						<Route path="/" component={Home} />
					</Switch>
				</ApolloProvider>
			</Router>
		</div>
	);
}
